import React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { Telemetry } from '~src/commonInfra/services/Telemetry';
import { TelemetryEvents, VPCFeatureUsageEvent } from '~src/commonInfra/telemetryEvents/TelemetryEvents';

import { ExplorerTestIds } from '../Explorer/ExplorerTestIds';
import { SpaceHeaderTestIds } from './SpaceHeader';

export const featureName = 'CompactHeader';
export type ExtraInformation = {
    headerWidth: number;
    pageWidth: number;
    descriptionHeight: number;
}

export function useHeaderTelemetry() {
    React.useEffect(() => {
        setTimeout(() => {
            const spaceInfo = getAppStore().getState()?.spaceInfo;
            const elementUnderHeader = document.querySelector(`[data-tb-test-id="${ExplorerTestIds.ExplorerMainArea}"]`);
            const descriptionElement = document.querySelector(`[data-tb-test-id="${SpaceHeaderTestIds.description}"]`);
            if (spaceInfo) {
                const extraInfomation: ExtraInformation = {
                    headerWidth: elementUnderHeader?.clientWidth,
                    pageWidth: document.body?.clientWidth,
                    descriptionHeight: descriptionElement?.clientHeight
                };

                Telemetry.sendEvent<VPCFeatureUsageEvent>({
                    type: TelemetryEvents.VPCFeatureUsage,
                    feature_name: featureName,
                    usage_type: 'impression',
                    extra_parameter_a: spaceInfo.spaceType,
                    extra_parameter_b: JSON.stringify(extraInfomation),
                    extra_parameter_c: FeatureFlags.compactHeaderEnabled ? 1 : 0,
                    extra_parameter_d: elementUnderHeader?.getBoundingClientRect().top,
                });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, []);
}